import React, { useCallback, useMemo, useState } from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { useShowAlert } from 'hooks';
import API from 'services/API';
import strings from 'strings';
import { TextBox } from 'UI/components/atoms';
import FPButtonBuilder from 'UI/components/molecules/FPButtonBuilder';
import FPDrawer from 'UI/components/templates/FPDrawer/FPDrawer';

import { COPIES, ENDPOINTS_BY_ENTITY } from './ClaimAccountability.constants';

export const ClaimAccountabilityDrawer = ({
  entityId,
  entityType,
  onClose,
  onSuccess,
  open = true
}) => {
  const { showAlert } = useShowAlert();
  const [isSaving, setIsSaving] = useState(false);
  const [reason, setReason] = useState('');

  const isEmpty = !reason;

  const handleChange = (_name, text) => {
    setReason(text);
  };

  const handleSubmit = useCallback(async () => {
    try {
      setIsSaving(true);

      const endpoint = ENDPOINTS_BY_ENTITY[entityType].replace(':id', entityId);
      await API.post(endpoint, { reason });
      setIsSaving(false);
      showAlert({
        title: COPIES.success.title,
        body: COPIES.success.body
      });
      onSuccess && onSuccess();
    } catch (error) {
      setIsSaving(false);
      showAlert({
        title: strings.shared.ui.unknownError.title,
        error
      });
    }
  }, [entityType, entityId, reason, showAlert, onSuccess]);

  const buttonDefinitions = useMemo(
    () => [
      {
        props: {
          text: strings.shared.ui.close,
          variant: 'outlined',
          onClick: onClose
        },
        GridItemProps: {
          md: 3
        }
      },
      {
        props: {
          disabled: isEmpty || isSaving,
          initialText: COPIES.successButton,
          isSaving,
          onClick: handleSubmit,
          onProgressText: strings.shared.ui.saving,
          type: 'submit',
          variant: 'contained'
        },
        GridItemProps: {
          md: 3
        },
        mode: 'save'
      }
    ],
    [handleSubmit, isSaving, onClose, isEmpty]
  );

  return (
    <FPDrawer
      CardHeaderProps={{ title: COPIES.title }}
      FPDrawerProps={{
        open,
        onClose
      }}
      onClose={onClose}
      footer={
        <FPButtonBuilder
          GridContainerProps={{ spacing: 2 }}
          buttonDefinitions={buttonDefinitions}
        />
      }
    >
      <Box display="flex" flexDirection="column" gridGap={32}>
        <Typography color="textSecondary">
          {COPIES.content.firstLine}
          <br />
          <br />
          {COPIES.content.secondLine}
        </Typography>

        <TextBox
          autoFocus
          fullWidth
          label={COPIES.textBoxLabel}
          multiline
          name="reason"
          noMargin
          onChange={handleChange}
          placeholder={COPIES.textBoxPlaceholder}
          value={reason}
          rows={8}
        />
      </Box>
    </FPDrawer>
  );
};
